import { UnshadowedElement, html } from "../lib/unshadowed.js";
import { PostJSON } from "../lib/fetchers.js";

const STORAGE_KEY = "recent";

/**
 * Loads the "Recently Visited" list for the Find page
 */
export class RecentTrains extends UnshadowedElement {
    static elementName() { return "recent-trains" }

    static properties = {
        trainLinks: { state: true, type: Array },
    };

    async connectedCallback() {
        super.connectedCallback();
        let recent;
        try {
            recent = localStorage.getItem(STORAGE_KEY);
        } catch {
            return;
        }
        if (!recent) return;
        try {
            const result = await PostJSON("/trains/linklist/", { recent });
            this.trainLinks = result.obj;
        } catch {
            // stay hidden
        }
    }

    Clear() {
        try {
            localStorage.removeItem(STORAGE_KEY);
        } catch {
            // Nothing to clear if storage is unavailable
        }
        this.trainLinks = undefined;
    }

    render() {
        if (!this.trainLinks?.length) return null;

        return html`
            <div class="space:stack:space-m">
                <h2 class="font:label-s space:stack:space-xs">Recently Visited</h2>
                <div class="slim-card-list">
                    ${this.trainLinks.map(link => html`
                        <a href=${link.OpenUrl} class="card link-card recent-card horizontal">
                            <div class="image-holder">${link.PhotoUrl ? html`<img src=${link.PhotoUrl} alt="" />` : null}</div>
                            <div class="card-content">
                                <h2 class="font:body-s">${link.Type} for <span class="name strong">${link.Name}</span></h2>
                            </div>
                        </a>
                    `)}
                </div>
                <button class="button button-link clear-button underline" @click=${this.Clear}>Clear List</button>
            </div>
            <div class="hr-text-divider">
                <p class="font:label-xs">or</p>
            </div>
        `;
    }
}
